const CLIENTS_ROUTES = {
  path: '/clients',
  component: () => import('@/pages/Clients/ClientsPagesContainer.vue'),
  children: [
    {
      path: '',
      name: 'clients.index',
      component: () => import('@/pages/Clients/ClientsPage.vue'),
    },
    {
      path: 'create',
      name: 'clients.create',
      component: () => import('@/pages/Clients/ClientsFormPage.vue'),
    },
    {
      path: ':id/edit',
      name: 'clients.edit',
      component: () => import('@/pages/Clients/ClientsFormPage.vue'),
    },
  ],
};

export default CLIENTS_ROUTES;
